module.exports = __webpack_public_path__ + "img/MRVL.OQ.517a831c.png";